<template>
    <div>
        <div class="container">
            <dl class="mb-2em" v-if="cards.length > 0">
                <dt>登録済のカード</dt>
                <dd>
                    <ul class="card_list">
                        <li v-for="(card, index) in cards" v-bind:key="index">
                            <span>
                                <input type="radio" name="selected" class="radio-input" v-model="selected" :value="card.id" :id="'card_' + card.id" />
                                <label :for="'card_' + card.id">
                                    <div v-if="card.brand === 'amex'" class="di">
                                        <CardAmericanExpress />
                                    </div>
                                    <div v-else-if="card.brand === 'diners'" class="di">
                                        <CardDinersClub />
                                    </div>
                                    <div v-else-if="card.brand === 'discover'" class="di">
                                        <CardDiscover />
                                    </div>
                                    <div v-else-if="card.brand === 'jcb'" class="di">
                                        <CardJCB />
                                    </div>
                                    <div v-else-if="card.brand === 'mastercard'" class="di">
                                        <CardMastercard />
                                    </div>
                                    <div v-else-if="card.brand === 'visa'" class="di">
                                        <CardVisa />
                                    </div>
                                    <div v-else class="di">
                                        <div class="di">{{ card.brand }}</div>
                                    </div>
                                </label>
                            </span>
                            <span>&#183;&#183;&#183;&#183; {{ card.last4 }}</span>
                            <span class="text-right">{{ ("00" + card.expMonth).slice(-2) + "/" + ("00" + card.expYear).slice(-2) }}</span>
                            <span>
                                <span v-if="dispDelete">
                                    <div v-if="!card.isUsing">
                                        <a class="btn_delete" @click="deleteCard(card.id)"></a>
                                    </div>
                                </span>
                            </span>
                        </li>
                    </ul>
                    <!-- card_list -->
                </dd>
            </dl>
            <div class="pl-08em" v-if="dispNoCard">
                <input type="radio" name="selected" v-model="selected" value="noCard" id="noCard" class="radio-input" />
                <label for="noCard">カードを追加しない</label>
            </div>
            <div class="pl-08em">
                <input type="radio" name="selected" v-model="selected" value="new" id="newCard" class="radio-input" />
                <label for="newCard">新しいカードを追加</label>
            </div>
            <transition>
                <div v-show="selected === 'new'" class="pt-05em">
                    <form method="post" id="payment-form">
                        <dl>
                            <label for="card-number" data-tid="elements.form.card_number_label">
                                <dt>
                                    <div class="col4 col4-sp pd-0">カード番号</div>
                                    <div class="col8 col8-sp text-right pd-0">
                                        <CardAmericanExpress />&nbsp; <CardDinersClub />&nbsp; <CardDiscover />&nbsp; <CardJCB />&nbsp; <CardMastercard />&nbsp;
                                        <CardVisa />
                                    </div>
                                </dt>
                            </label>
                            <dd>
                                <div id="card-number" class="input empty"></div>
                            </dd>
                        </dl>

                        <div class="flex align-center mt-2em">
                            <dl class="mr-2em w140">
                                <label for="card-expiry" data-tid="elements.form.card_expiry_label">
                                    <dt>有効期限</dt>
                                </label>
                                <dd>
                                    <div id="card-expiry" class="input empty"></div>
                                </dd>
                            </dl>

                            <dl class="mt-0 w140">
                                <div class="flex">
                                    <label for="card-cvc" data-tid="elements.form.card_cvc_label">
                                        <dt>CVC</dt>
                                    </label>
                                    <span @click="cvcInformationClick" class="ml-05em">
                                        <IconInformation />
                                    </span>
                                </div>
                                <dd>
                                    <div id="card-cvc" class="input empty"></div>
                                </dd>
                            </dl>
                        </div>
                    </form>
                </div>
            </transition>
            <p class="mt-2em" v-if="defaultCardEnabled">
                <input type="checkbox" name id="policy" v-model="setDefault" />
                <label for="policy">今回のカードをデフォルトにする</label>
            </p>

            <div ref="cardNumber" />
            <div ref="cardExpiry" />
            <div ref="cardCvc" />
        </div>
    </div>
</template>

<script>
import CardAmericanExpress from "./icons/CardAmericanExpress.vue";
import CardDinersClub from "./icons/CardDinersClub.vue";
import CardDiscover from "./icons/CardDiscover.vue";
import CardJCB from "./icons/CardJCB.vue";
import CardMastercard from "./icons/CardMastercard.vue";
import CardVisa from "./icons/CardVisa.vue";
import IconInformation from "./icons/IconInformation.vue";
const stripe = Stripe(process.env.VUE_APP_API_KEY); // eslint-disable-line
const elements = stripe.elements();
let cardNumber;
let cardExpiry;
let cardCvc;

export default {
    components: {
        CardAmericanExpress,
        CardDinersClub,
        CardDiscover,
        CardJCB,
        CardMastercard,
        CardVisa,
        IconInformation
    },
    props: ["currentCards", "deletable", "noCard", "invoiceClientSecret", "noDefault", "defaultCardEnabled"],
    data: function () {
        return {
            cards: [],
            selected: "new",
            setDefault: false,
            dispDelete: this.deletable,
            dispNoCard: this.noCard,
            defaultCardEnabled: this.defaultCardEnabled || false
        };
    },
    watch: {
        // eslint-disable-next-line no-unused-vars
        currentCards: function (newCards, oldCards) {
            this.updateCards(newCards);
        }
    },
    methods: {
        updateCards: function (cards) {
            this.dispNoCard = this.noCard;
            this.cards = cards;
            if (this.cards.length > 0) {
                // カードが登録されている場合
                this.dispNoCard = false;
                for (const card of this.cards) {
                    if (card.isDefault) {
                        this.selected = card.id;
                    }
                }
            } else {
                // カードが未登録の場合
                if (this.dispNoCard) {
                    this.selected = "noCard";
                } else {
                    this.selected = "new";
                }
            }
        },
        deleteCard: function (cardId) {
            this.$emit("showSpinner", "処理中です。");

            this.$axios(
                "POST",
                "/api/personal/personal/deleteCard",
                {
                    cardId: cardId
                },
                // eslint-disable-next-line
                (res) => {
                    this.$emit("hideSpinner");
                    this.updateCards(res.data.cards);
                }
            );
        },
        payInvoice: function (clientSecret) {
            return new Promise((resolve, reject) => {
                if (this.selected === "noCard") {
                    resolve({});
                    return;
                }

                try {
                    let card;
                    if (this.selected !== "new") {
                        card = this.selected;
                    } else {
                        card = {
                            card: cardNumber
                        };
                    }
                    stripe
                        .confirmCardPayment(clientSecret, {
                            payment_method: card
                        })
                        .then(function (result) {
                            if (result.error) {
                                reject(result.error);
                                return;
                            }
                            resolve({
                                paymentIntent: result.paymentIntent
                            });
                        });
                } catch (err) {
                    reject(err);
                }
            });
        },
        cardSetup: function (setupClientSecret) {
            return new Promise((resolve, reject) => {
                if (this.selected === "noCard") {
                    resolve({});
                    return;
                }
                try {
                    let paymentMethod;
                    if (this.selected !== "new") {
                        paymentMethod = this.selected;
                    } else {
                        paymentMethod = {
                            card: cardNumber,
                            metadata: {
                                created: new Date().getTime()
                            }
                        };
                    }
                    const thisSelected = this.selected;
                    stripe
                        .confirmCardSetup(setupClientSecret, {
                            payment_method: paymentMethod
                        })
                        .then(function (result) {
                            if (result.error) {
                                reject(result.error);
                                return;
                            }
                            resolve({
                                setupIntent: result.setupIntent,
                                isNewCardSelected: thisSelected === "new"
                            });
                        });
                } catch (err) {
                    reject(err);
                }
            });
        },
        isCardSelect: function () {
            if (this.selected === "noCard") {
                return false;
            }
            return true;
        },
        isNewCardSelected: function () {
            return this.selected === "new";
        },
        isDefaultSet: function () {
            return this.setDefault;
        },
        getSelectedCardId: function () {
            if (this.selected === "noCard" || this.selected === "new") {
                return null;
            }
            return this.selected;
        },
        cvcInformationClick: function () {
            this.$emit(
                "infoClick",
                "クレジットカードに記載されている固有の番号です。通常、カード裏面の署名欄付近に記載された3桁の番号です。一部カードブランド（AMEX等）では、前面に4桁で記載されています。",
                null
            );
        },
        clearNewCardElements: function () {
            cardNumber.clear();
            cardExpiry.clear();
            cardCvc.clear();
        }
    },
    created() {
        this.updateCards(this.currentCards || []);
    },
    mounted() {
        const elementStyles = {
            base: {
                backgroundColor: "#f7f7f7",
                color: "#32325D",
                fontSize: "16px",
                fontSmoothing: "antialiased",
                fontWeight: 400,
                lineHeight: "28px",
                "::placeholder": {
                    color: "#CFD7DF"
                },
                ":-webkit-autofill": {
                    color: "#e39f48"
                }
            },
            invalid: {
                color: "#E25950",
                "::placeholder": {
                    color: "#FFCCA5"
                }
            }
        };

        const elementClasses = {
            focus: "focused",
            empty: "empty",
            invalid: "invalid"
        };

        cardNumber = elements.create("cardNumber", {
            showIcon: true,
            style: elementStyles,
            classes: elementClasses
        });
        cardNumber.mount("#card-number");

        cardExpiry = elements.create("cardExpiry", {
            style: elementStyles,
            classes: elementClasses
        });
        cardExpiry.mount("#card-expiry");

        cardCvc = elements.create("cardCvc", {
            style: elementStyles,
            classes: elementClasses
        });
        cardCvc.mount("#card-cvc");
    },
    beforeUnmount() {
        cardNumber.destroy(this.$refs.cardNumber);
        cardExpiry.destroy(this.$refs.cardExpiry);
        cardCvc.destroy(this.$refs.cardCvc);
    }
};
</script>

<style scoped>
.w140 {
    width: 140px;
}

.v-enter-active {
    transition: opacity 0.5s;
}

.v-leave-active {
    transition: opacity 0s;
}
y .v-enter,
.v-leave-to {
    opacity: 0;
}

.pl-08em {
    padding-left: 0.8rem !important;
}
</style>
